<template>
  <v-app :style="isDevEnv ? { '--env-banner-height': '20px' } : {}">
    <env-banner v-if="isDevEnv"></env-banner>

    <!-- IF USER IS NOT LOGGED IN -->
    <login-view v-if="!isLoggedIn && !$route.meta.isPublic"></login-view>

    <!-- If USER IS LOGGED IN -->
    <v-main v-else>
      <router-view />
      <snackbar></snackbar>
      <!-- Ctrl+K from anywhere, so finding a feature does not depend on knowing
           which page it lives on. -->
      <feature-search></feature-search>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {
    'login-view' : () => import('@/views/LoginView'),
    'snackbar'   : () => import('@/components/shared/Snackbar.vue'),
    'env-banner' : () => import('@/components/shared/EnvBanner.vue'),
    'feature-search' : () => import('@/components/shared/FeatureSearch.vue')
  },
  data: () => ({

  }),
  computed: {
    isLoggedIn() {
      return this.$store.getters.IS_AUTHENTICATED
    },
    isDevEnv() {
      return process.env.VUE_APP_ENV !== 'production'
    },
  },
};
</script>
